import { Component, ContentChild, HostBinding, HostListener, Input, TemplateRef } from '@angular/core'
import { CountUpDirective } from 'src/app/shared/directives/count-up.directive'
import { SimpleStatTemplateDirective } from './simple-stat-custom-tmp'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'sf-simple-stat-box',
    imports: [CountUpDirective, CommonModule],
    templateUrl: './simple-stat-box.component.html',
    styleUrls: ['./simple-stat-box.component.scss'],
    host: { class: 'statbox' }
})
export class SimpleStatBoxComponent {
    @Input({ required: true })
    count: number = 0

    @Input({ required: true })
    heading: string = ''

    @HostBinding('style.borderColor')
    @Input()
    color: string = '#000000'

    @ContentChild(SimpleStatTemplateDirective, { read: TemplateRef })
    statTemplate: TemplateRef<unknown> | undefined
}
